import store from '@/store'

export const addToast = (type, content, title) => {
  store.dispatch('addToastAction', {
    type: type,
    title: title,
    content: content
  })
}